import { call, put } from "redux-saga/effects";
import { commonService } from "../services/commonService";
import { commonConstants } from "../actions/constants/commonConstants";

function* createService(action:any): any {
  try {
    const response = yield call(commonService.createService, action.payload);
    if (response.success) {
      yield put({ type: commonConstants.createServiceSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: commonConstants.createServiceFailure, payload: response.errorMessage });
       yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.createServiceFailure, payload: error });
     yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* getService(action:any): any {
  try {
    const response = yield call(commonService.getService,action.payload);
    if (response.success) {
      yield put({ type: commonConstants.getServiceSuccess, payload: response.resultObject });
    } else {
      yield put({ type: commonConstants.getServiceFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.getServiceFailure, payload: error });
  }
}

function* getServiceParams(action:any): any {
  try {
    const response = yield call(commonService.getServiceParams, action.payload);
    if (response.success) {
      yield put({ type: commonConstants.getServiceParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: commonConstants.getServiceParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.getServiceParamsFailure, payload: error });
  }
}

function* getServiceView(action:any): any {
  try {
    const response = yield call(commonService.getServiceView, action.payload);
    if (response.success) {
      yield put({ type: commonConstants.serviceViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: commonConstants.serviceViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.serviceViewFailure, payload: error });
  }
}

function* toggleService(action:any): any {
  try {
    const response = yield call(commonService.toggleService, action.payload);
    if (response.success) {
      yield put({ type: commonConstants.serviceToggleSuccess, payload: response.resultObject });
    } else {
      yield put({ type: commonConstants.serviceToggleFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.serviceToggleFailure, payload: error });
  }
}

function* deleteService(action:any): any {
  try {
    const response = yield call(commonService.deleteService, action.payload);
    if (response.success) {
      yield put({ type: commonConstants.deleteServiceSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: commonConstants.deleteServiceFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.deleteServiceFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* deleteFiles(action:any): any {
  try {
    const response = yield call(commonService.deleteFiles, action.payload);
    
    if (response.success) {
      yield put({ type: commonConstants.fileDeleteSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: commonConstants.fileDeleteFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {

    yield put({ type: commonConstants.fileDeleteFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* sendMail(action:any): any {
  try {
    const response = yield call(commonService.contactMailService, action.payload);
    
    if (response.success) {
      yield put({ type: commonConstants.contactEmailSuccess, payload: response.resultObject });
    } else {
      yield put({ type: commonConstants.contactEmailFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: commonConstants.contactEmailFailure, payload: error });
  }
}

export const commonSaga = {
  getService,
  getServiceParams,
  getServiceView,
  deleteService,
  toggleService,
  createService,
  deleteFiles,
  sendMail
};



// (deleteFiles included in export above)